import {
  useAddOnFilter,
  useCurrentWorkspace,
  useSetAddOnFilter,
} from '@gripp/shared-logic';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { TextInput } from 'react-native-paper';
import { Colors } from '../../themes';
import { DebouncedTextInput } from '../forms';

export const AddOnSearchInput = () => {
  const { t } = useTranslation();
  const { data: addOnFilter } = useAddOnFilter();
  const { mutateAsync: setAddOnFilter } = useSetAddOnFilter();

  const currentWorkspaceId = useCurrentWorkspace();

  const [text, setText] = useState('');

  useEffect(() => {
    if (!text && addOnFilter?.keyword) {
      setText(addOnFilter.keyword);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addOnFilter?.keyword]);

  const updateSearch = async (term: string) => {
    if (!addOnFilter) return;
    addOnFilter.keyword = term;
    await setAddOnFilter(addOnFilter);
  };

  return (
    addOnFilter && (
      <DebouncedTextInput
        debounceTimeMs={500}
        debounceFunc={updateSearch}
        placeholder={t('addOn.filter.searchPlaceholder')}
        value={text}
        onBlur={() => null}
        onChangeText={(text) => setText(text)}
        left={<TextInput.Icon icon="magnify" color={Colors.grayFill} />}
        right={
          text ? (
            <TextInput.Icon
              icon="close"
              size={20}
              color={Colors.black}
              onPress={() => setText('')}
            />
          ) : (
            <View />
          )
        }
        height={44}
        outlineStyle={styles.inputStyle}
        disableInnerStyle={true}
      />
    )
  );
};

const styles = StyleSheet.create({
  inputStyle: {
    backgroundColor: Colors.white,
    borderColor: Colors.grayDivider,
    borderWidth: 1,
    borderRadius: 8,
  },
});
